<template>
  <div class="tw-flex tw-shrink-0 tw-relative">
    <div class="tw-flex tw-space-x-2 tw-items-center">
      <avatar-icon
        :user="user"
        :size="size"
        :input-loading="inputLoading"
        :show-status="showStatus"
      />
      <template v-if="$slots.right">
        <slot name="right" />
      </template>
    </div>
  </div>
</template>

<script>
import AvatarIcon from '@components/Users/AvatarIcon.vue'

export default {
  components: {
    AvatarIcon,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
    },
    inputLoading: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s 0.5s ease;
}
.fade-enter-from,
.fade-leave-active {
  opacity: 0;
  transition: none;
}
</style>
